// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'relativePro', 'relativePro Fallback'"},"className":"__className_e9df96","variable":"__variable_e9df96"};